import _str from "shared/util/_str";

export const DESCRIPTIONS = [
	{
		header: _str("Get ultimate privacy. Go incognito!"),
		paragraph: _str("Your profile will only be visible to people you like or message."),
	},
	{
		header: _str("See but don’t be seen. It’s that simple."),
		paragraph: _str("Browse freely, your profile won’t appear anywhere—not even in search."),
	},
	{
		header: _str("You’re always in complete control."),
		paragraph: _str("Revoke a person’s access to your profile by passing on them or blocking them."),
	},
	{
		header: _str("Craving a bit more attention?"),
		paragraph: _str("We get it. Turn Incognito Mode on and off whenever you want!"),
	},
];



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/util/constants.js